module.exports = __webpack_public_path__ + "img/ailments-bg.6f738138.jpg";